import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "plan-header" }
const _hoisted_3 = { class: "plan-breadcrumbs" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-close" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "modal-actions"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "modal-actions"
}
const _hoisted_10 = {
  key: 2,
  class: "modal-actions"
}
const _hoisted_11 = {
  key: 3,
  class: "modal-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "close-btn close-plan-modal",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, _hoisted_5)
        ])
      ]),
      _createElementVNode("i", {
        class: _normalizeClass(_ctx.modalProps.content.icon)
      }, null, 2),
      _createElementVNode("h2", null, _toDisplayString(_ctx.modalProps.title), 1),
      (_ctx.modalProps.content.type === 'text')
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            innerHTML: _ctx.modalProps.content.value
          }, null, 8, _hoisted_6))
        : (_openBlock(), _createBlock(_component_RadioButton, {
            key: 1,
            options: _ctx.modalProps.content.value,
            name: _ctx.modalProps.content?.name,
            modelValue: _ctx.selectedValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedValue) = $event))
          }, null, 8, ["options", "name", "modelValue"]))
    ]),
    (_ctx.orderedButtons.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedButtons, (btn, index) => {
            return (_openBlock(), _createElementBlock("a", {
              key: index,
              href: "",
              class: _normalizeClass(["btn plan-modal", {
                'btn-primary': (index === 0 && (_ctx.modalProps.order ?? 0) === 1) || (index === 1 && (_ctx.modalProps.order ?? 0) === 0),
                'btn-secondary': (index === 0 && (_ctx.modalProps.order ?? 0) === 0) || (index === 1 && (_ctx.modalProps.order ?? 0) === 1)
            }]),
              onClick: _withModifiers(($event: any) => (_ctx.handleButtonClick(index)), ["prevent"])
            }, _toDisplayString(btn), 11, _hoisted_8))
          }), 128))
        ]))
      : (_ctx.modalProps.onConfirm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_ctx.modalProps.onConfirmButton)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  class: "btn btn-secondary plan-modal",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.modalProps.onConfirmButton), 1))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("a", {
                    href: "",
                    class: "btn btn-secondary plan-modal",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
                  }, " Cancel "),
                  _createElementVNode("a", {
                    href: "",
                    class: "btn btn-primary plan-modal",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
                  }, " Save ")
                ], 64))
          ]))
        : (_ctx.modalProps.closeSelf)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("a", {
                href: "",
                class: "btn btn-secondary plan-modal",
                onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
              }, " Ok ")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("a", {
                href: "",
                class: "btn btn-secondary plan-modal",
                onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeAbove && _ctx.closeAbove(...args)), ["prevent"]))
              }, _toDisplayString(_ctx.modalProps.onConfirmButton ? _ctx.modalProps.onConfirmButton : 'Ok'), 1)
            ]))
  ], 64))
}